document.getElementById('touch-menu-button').addEventListener('click', () => {
	document.getElementsByTagName('body')[0].classList.toggle('touch-menu-open')
})

document.getElementById('touch-menu-close').addEventListener('click', () => {
	document.getElementsByTagName('body')[0].classList.remove('touch-menu-open')
})

if (typeof NodeList.prototype.forEach !== 'function')  {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

if(document.querySelectorAll('.navbar-mega-menu > a.navbar-touch-expand').length > 0) {
	document.querySelectorAll('.navbar-mega-menu > a.navbar-touch-expand').forEach((el) => {
		el.addEventListener('click', () => {
			el.parentElement.classList.toggle('is-open')
		})
	})
}




// WEBPACK FOOTER //
// ./scripts/lib/touch-menu.js